import { render, staticRenderFns } from "./PersonSpecificationHelper.vue?vue&type=template&id=264d7f30&scoped=true&"
import script from "./PersonSpecificationHelper.vue?vue&type=script&lang=js&"
export * from "./PersonSpecificationHelper.vue?vue&type=script&lang=js&"
import style0 from "./PersonSpecificationHelper.vue?vue&type=style&index=0&id=264d7f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d7f30",
  null
  
)

export default component.exports